module.exports = __webpack_public_path__ + "img/banner-bg.9dc66f0f.jpg";